module.exports = {
  formTypes: [
    { value: 'patient_facing_form', label: 'Patient-facing Form' },
    { value: 'clinical_template', label: 'Clinical Template' }
  ]
};
